import { apiRequest } from 'utils/request'

export const getAPIVersion = () =>
  apiRequest({
    uri: '/version',
  })
